import { Injectable }   from '@angular/core';
import { Router }       from '@angular/router';
import { CanActivate }  from '@angular/router';
import { Auth }         from '../auth.service';
import { AdminService }         from '../admins/admin.service';


@Injectable()
export class NotLoggedIn implements CanActivate {

  constructor(private auth: Auth, private router: Router, private adminService:AdminService) {}
  isAdmin:boolean=false

canActivate() {

    if(this.auth.authenticated()) {
    
      this.router.navigate(['dashboard']);
      return false;
    } else {
    
      return true;
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/app/services/activators/not-logged-in.service.ts